import React from 'react';

function Pakistan(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124024)">
        <mask
          id="mask0_800_124024"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124024)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 0H36V24H9V0Z"
            fill="#2F8D00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H9V24H0V0Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.2331 15.3062C25.2331 15.3062 20.2091 16.4705 16.2213 14.0956C12.2336 11.7206 14.2382 6.24775 14.2382 6.24775C12.1581 6.5168 8.89149 13.2627 14.157 16.6461C19.4224 20.0296 24.4667 16.7772 25.2331 15.3062ZM19.658 8.86648L16.9901 10.0261L19.8047 10.4717L20.1846 12.9172L21.7788 10.8344L24.9158 11.0225L22.4588 9.39356L23.7668 7.2172L21.3207 8.21305L19.5035 6.69438L19.658 8.86648Z"
            fill="#F1F9FF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124024">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Pakistan;
